// // PaymentPage.jsx
// // Updated: 06-04-2026
// // Changes:
// // - "Record Payment" button removed — payments are now triggered by clicking a PendingDealCard
// // - pendingDeals state added — fetched from GET /payments/pending-deals
// // - Page split into two sections: "Awaiting Payment" (PendingDealCard list) + "Recorded Payments" (PaymentCard list)
// // - selectedDeal state added — holds the deal passed into PaymentForm when recording from a card
// // - fetchData now also refreshes pendingDeals after every save so the card disappears immediately
// // - PaymentCard deal lookup fixed: dealId is now a populated object from the backend

// import React, { useEffect, useState } from "react";
// import { Search } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";

// import "../css/payments/paymentpage.css";
// import PaymentFilters from "../components/payments/PaymentFilter";
// import PaymentForm    from "../components/payments/PaymentForm";
// import PaymentCard    from "../components/payments/PaymentCard";
// import PendingDealCard from "../components/payments/PendingDealCard";
// import api from "../api/api";

// export default function Payments() {
//   const [payments,     setPayments]     = useState([]);
//   const [pendingDeals, setPendingDeals] = useState([]);   // NEW — deals awaiting payment
//   const [deals,        setDeals]        = useState([]);   // still needed for PaymentCard lookup
//   const [loading,      setLoading]      = useState(true);

//   const [showForm,       setShowForm]       = useState(false);
//   const [editingPayment, setEditingPayment] = useState(null);
//   const [selectedDeal,   setSelectedDeal]   = useState(null); // NEW — deal clicked on PendingDealCard

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filters,    setFilters]    = useState({ status: "all", paymentType: "all" });

//   /* ─────────────────── FETCH ─────────────────── */
//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const [paymentsRes, pendingRes, dealsRes] = await Promise.all([
//         api.get("/payments"),
//         api.get("/payments/pending-deals"),   // NEW
//         api.get("/deals"),
//       ]);

//       setPayments(
//         Array.isArray(paymentsRes.data) ? paymentsRes.data : paymentsRes.data.data || []
//       );
//       setPendingDeals(
//         Array.isArray(pendingRes.data) ? pendingRes.data : pendingRes.data.data || []
//       );
//       setDeals(
//         Array.isArray(dealsRes.data) ? dealsRes.data : dealsRes.data.data || []
//       );
//     } catch (err) {
//       console.error("Failed to load data", err);
//       setPayments([]);
//       setPendingDeals([]);
//       setDeals([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchData(); }, []);

//   /* ─────────────────── SAVE PAYMENT ─────────────────── */
//   const handleSubmit = async (data) => {
//     const payload = { ...data };
//     if (payload.dealId === "all") delete payload.dealId;

//     try {
//       if (editingPayment) {
//         await api.put(`/payments/${editingPayment._id}`, payload);
//       } else {
//         await api.post("/payments", payload);
//       }
//       await fetchData();          // refreshes both lists — pending card disappears, recorded list grows
//       setShowForm(false);
//       setEditingPayment(null);
//       setSelectedDeal(null);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const closeForm = () => {
//     setShowForm(false);
//     setEditingPayment(null);
//     setSelectedDeal(null);
//   };

//   /* ─────────────────── FILTER LOGIC ─────────────────── */
//   const filteredPayments = payments.filter((payment) => {
//     // dealId is populated by backend — it's an object { _id, dealName, ... }
//     const dealName = payment.dealId?.dealName || "";

//     const matchesSearch =
//       dealName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       payment.transactionRef?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesStatus =
//       filters.status === "all" || payment.status === filters.status;

//     const matchesType =
//       filters.paymentType === "all" || payment.paymentType === filters.paymentType;

//     return matchesSearch && matchesStatus && matchesType;
//   });

//   /* ─────────────────── TOTALS ─────────────────── */
//   const totalReceived = payments
//     .filter((p) => p.status === "Received")
//     .reduce((sum, p) => sum + p.amount, 0);

//   const totalPending = payments
//     .filter((p) => p.status === "Pending")
//     .reduce((sum, p) => sum + p.amount, 0);

//   /* ─────────────────── UI ─────────────────── */
//   return (
//     <div className="payments-page">
//       <div className="payments-container">

//         {/* ── Header ── */}
//         <div className="payments-header">
//           <div>
//             <h1>Payment Tracking</h1>
//             <p className="subtitle">Monitor payments and commissions</p>
//             <div className="totals">
//               <span className="received">Received: ₹{(totalReceived / 1000).toFixed(0)}K</span>
//               <span className="pending">Pending: ₹{(totalPending / 1000).toFixed(0)}K</span>
//             </div>
//           </div>
//           {/* "Record Payment" button removed — use PendingDealCard instead */}
//         </div>

//         {/* ── Search & Filters ── */}
//         <div className="payments-toolbar">
//           <div className="search-box">
//             <Search size={16} />
//             <input
//               type="text"
//               placeholder="Search by deal or transaction ref..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
//           <PaymentFilters filters={filters} setFilters={setFilters} />
//         </div>

//         {/* ── Section 1: Deals awaiting payment ── */}
//         {!loading && pendingDeals.length > 0 && (
//           <div className="pending-deals-section">
//             <h2 className="section-title">
//               Awaiting Payment
//               <span className="section-count">{pendingDeals.length}</span>
//             </h2>
//             <div className="payments-grid">
//               {pendingDeals.map((deal, index) => (
//                 <PendingDealCard
//                   key={deal._id}
//                   deal={deal}
//                   index={index}
//                   onRecordPayment={(deal) => {
//                     setSelectedDeal(deal);
//                     setEditingPayment(null);
//                     setShowForm(true);
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* ── Section 2: Recorded payments ── */}
//         <div className="recorded-section">
//           {pendingDeals.length > 0 && (
//             <h2 className="section-title">
//               Recorded Payments
//               <span className="section-count">{filteredPayments.length}</span>
//             </h2>
//           )}
//           <div className="payments-grid">
//             <AnimatePresence>
//               {loading ? (
//                 <div className="state-msg">Loading payments...</div>
//               ) : filteredPayments.length === 0 ? (
//                 <div className="state-msg">No payments recorded</div>
//               ) : (
//                 filteredPayments.map((payment, index) => (
//                   <PaymentCard
//                     key={payment._id}
//                     payment={payment}
//                     deal={payment.dealId}   // backend populates this as an object
//                     index={index}
//                     onEdit={() => {
//                       setEditingPayment(payment);
//                       setSelectedDeal(null);
//                       setShowForm(true);
//                     }}
//                   />
//                 ))
//               )}
//             </AnimatePresence>
//           </div>
//         </div>

//         {/* ── PaymentForm modal ── */}
//         <AnimatePresence>
//           {showForm && (
//             <motion.div
//               className="payment-modal-overlay"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               onClick={closeForm}
//             >
//               <motion.div
//                 className="payment-modal-content"
//                 initial={{ scale: 0.9, opacity: 0 }}
//                 animate={{ scale: 1, opacity: 1 }}
//                 exit={{ scale: 0.9, opacity: 0 }}
//                 transition={{ duration: 0.2 }}
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <PaymentForm
//                   payment={editingPayment}
//                   deal={selectedDeal}       // pre-fills form when coming from PendingDealCard
//                   deals={deals}
//                   onSubmit={handleSubmit}
//                   onCancel={closeForm}
//                   isLoading={false}
//                 />
//               </motion.div>
//             </motion.div>
//           )}
//         </AnimatePresence>

//       </div>
//     </div>
//   );
// }

// PaymentPage.jsx
// Updated: 06-04-2026
// Changes:
// - "Record Payment" button removed — payments are now triggered by clicking a PendingDealCard
// - pendingDeals state added — fetched from GET /payments/pending-deals
// - Page split into two sections: "Awaiting Payment" (PendingDealCard list) + "Recorded Payments" (PaymentCard list)
// - selectedDeal state added — holds the deal passed into PaymentForm when recording from a card
// - fetchData now also refreshes pendingDeals after every save so the card disappears immediately
// - PaymentCard deal lookup fixed: dealId is now a populated object from the backend

import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

import "../css/payments/paymentpage.css";
import PaymentFilters from "../components/payments/PaymentFilter";
import PaymentForm    from "../components/payments/PaymentForm";
import PaymentCard    from "../components/payments/PaymentCard";
import PendingDealCard from "../components/payments/PendingDealCard";
import api from "../api/api";

export default function Payments() {
  const [payments,     setPayments]     = useState([]);
  const [pendingDeals, setPendingDeals] = useState([]);   // NEW — deals awaiting payment
  const [deals,        setDeals]        = useState([]);   // still needed for PaymentCard lookup
  const [loading,      setLoading]      = useState(true);

  const [showForm,       setShowForm]       = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);
  const [selectedDeal,   setSelectedDeal]   = useState(null); // NEW — deal clicked on PendingDealCard

  const [searchTerm, setSearchTerm] = useState("");
  const [filters,    setFilters]    = useState({ status: "all", paymentType: "all" });

  /* ─────────────────── FETCH ─────────────────── */
  const fetchData = async () => {
    setLoading(true);
    try {
      const [paymentsRes, pendingRes, dealsRes] = await Promise.all([
        api.get("/payments"),
        api.get("/payments/pending-deals"),   // NEW
        api.get("/deals"),
      ]);

      setPayments(
        Array.isArray(paymentsRes.data) ? paymentsRes.data : paymentsRes.data.data || []
      );
      setPendingDeals(
        Array.isArray(pendingRes.data) ? pendingRes.data : pendingRes.data.data || []
      );
      setDeals(
        Array.isArray(dealsRes.data) ? dealsRes.data : dealsRes.data.data || []
      );
    } catch (err) {
      console.error("Failed to load data", err);
      setPayments([]);
      setPendingDeals([]);
      setDeals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  /* ─────────────────── SAVE PAYMENT ─────────────────── */
  const handleSubmit = async (data) => {
    const payload = { ...data };
    if (payload.dealId === "all") delete payload.dealId;

    try {
      if (editingPayment) {
        await api.put(`/payments/${editingPayment._id}`, payload);
      } else {
        await api.post("/payments", payload);
      }
      await fetchData();          // refreshes both lists — pending card disappears, recorded list grows
      setShowForm(false);
      setEditingPayment(null);
      setSelectedDeal(null);
    } catch (err) {
      console.error(err);
    }
  };

  const closeForm = () => {
    setShowForm(false);
    setEditingPayment(null);
    setSelectedDeal(null);
  };

  /* ─────────────────── FILTER LOGIC ─────────────────── */
  const filteredPayments = payments.filter((payment) => {
    // dealId is populated by backend — it's an object { _id, dealName, ... }
    const dealName = payment.dealId?.dealName || "";

    const matchesSearch =
      dealName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      payment.transactionRef?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filters.status === "all" || payment.status === filters.status;

    const matchesType =
      filters.paymentType === "all" || payment.paymentType === filters.paymentType;

    return matchesSearch && matchesStatus && matchesType;
  });

  /* ─────────────────── TOTALS ─────────────────── */
  const totalReceived = payments
    .filter((p) => p.status === "Received")
    .reduce((sum, p) => sum + p.amount, 0);

  const totalPending = payments
    .filter((p) => p.status === "Pending")
    .reduce((sum, p) => sum + p.amount, 0);

  // Format amount: 2000 → "2K", 1500000 → "15L", 10000000 → "1Cr"
  const fmtAmt = (n) =>
    n >= 10_000_000
      ? `₹${(n / 10_000_000).toFixed(2)}Cr`
      : n >= 100_000
      ? `₹${(n / 100_000).toFixed(1)}L`
      : n >= 1000
      ? `₹${(n / 1000).toFixed(0)}K`
      : `₹${n}`;

  /* ─────────────────── UI ─────────────────── */
  return (
    <div className="payments-page">
      <div className="payments-container">

        {/* ── Header ── */}
        <div className="payments-header">
          <div>
            <h1>Payment Tracking</h1>
            <p className="subtitle">Monitor payments and commissions</p>
            <div className="totals">
              <span className="received">Received: {fmtAmt(totalReceived)}</span>
              <span className="pending">Pending: {fmtAmt(totalPending)}</span>
            </div>
          </div>
          {/* "Record Payment" button removed — use PendingDealCard instead */}
        </div>

        {/* ── Search & Filters ── */}
        <div className="payments-toolbar">
          <div className="search-box">
            <Search size={16} />
            <input
              type="text"
              placeholder="Search by deal or transaction ref..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <PaymentFilters filters={filters} setFilters={setFilters} />
        </div>

        {/* ── Section 1: Deals awaiting payment ── */}
        {!loading && pendingDeals.length > 0 && (
          <div className="pending-deals-section">
            <h2 className="section-title">
              Awaiting Payment
              <span className="section-count">{pendingDeals.length}</span>
            </h2>
            <div className="payments-grid">
              {pendingDeals.map((deal, index) => (
                <PendingDealCard
                  key={deal._id}
                  deal={deal}
                  index={index}
                  onRecordPayment={(deal) => {
                    setSelectedDeal(deal);
                    setEditingPayment(null);
                    setShowForm(true);
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* ── Section 2: Recorded payments ── */}
        <div className="recorded-section">
          {pendingDeals.length > 0 && (
            <h2 className="section-title">
              Recorded Payments
              <span className="section-count">{filteredPayments.length}</span>
            </h2>
          )}
          <div className="payments-grid">
            <AnimatePresence>
              {loading ? (
                <div className="state-msg">Loading payments...</div>
              ) : filteredPayments.length === 0 ? (
                <div className="state-msg">No payments recorded</div>
              ) : (
                filteredPayments.map((payment, index) => (
                  <PaymentCard
                    key={payment._id}
                    payment={payment}
                    deal={payment.dealId}   // backend populates this as an object
                    index={index}
                    fmtAmt={fmtAmt}
                    onEdit={() => {
                      setEditingPayment(payment);
                      setSelectedDeal(null);
                      setShowForm(true);
                    }}
                  />
                ))
              )}
            </AnimatePresence>
          </div>
        </div>

        {/* ── PaymentForm modal ── */}
        <AnimatePresence>
          {showForm && (
            <motion.div
              className="payment-modal-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeForm}
            >
              <motion.div
                className="payment-modal-content"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                transition={{ duration: 0.2 }}
                onClick={(e) => e.stopPropagation()}
              >
                <PaymentForm
                  payment={editingPayment}
                  deal={selectedDeal}       // pre-fills form when coming from PendingDealCard
                  deals={deals}
                  onSubmit={handleSubmit}
                  onCancel={closeForm}
                  isLoading={false}
                />
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

      </div>
    </div>
  );
}